import "bootstrap";
import * as Feather from "feather-icons";
import "flag-icon-css/sass/flag-icon.scss";

import "./scss/styles.scss";
import "./scss/linear-spinner.scss";

import "./components/table";
import "./components/card";
import Notifications from "./components/notifications";

import "./utils/custom-event-poly";
import "./utils/selector";
import initTruncatedComponents from "./utils/truncated_reveal";

Feather.replace();

window.feather = Feather;

// Hack to make sure table rows do not go below the navbar when refered to in url hash
let shiftWindow = function() {
    setTimeout(function() {
        scrollBy(0, -60);
    }, 100);
};
document.addEventListener("DOMContentLoaded", function() {
  if (location.hash) shiftWindow();
  initTruncatedComponents();
});
window.addEventListener("hashchange", shiftWindow);

let clickableRows = document.querySelectorAll(".clickable tbody tr");
clickableRows.forEach((row) => {
  row.addEventListener("click", (e) => {
    if(!e.target.getAttribute("is") && !e.target.classList.contains("check-select")) {
      window.document.location = e.currentTarget.getAttribute("data-href");
    }
  });
});

const notificationsElement = document.querySelector("#notificationsComponent");
if (notificationsElement) {
  let notificationsComponent = new Notifications(notificationsElement);
}
